import { CurrencyModel } from "../models/data/currency.model";

export class CurrencyUtilities {
  public static convertCurrencyStringToMinorUnits(amountStr: string, minorUnits: number): number {
    const amountValue = parseFloat(amountStr.replace(/,/g, ''));
    return CurrencyUtilities.convertMajorUnitsToMinor(amountValue, minorUnits);
  }

  public static convertMajorUnitsToMinor(amount: number, minorUnits: number): number {
    return Math.round(amount * minorUnits);
  }

  public static convertMinorUnitsToMajor(amount: number, minorUnits: number): number {
    return amount / minorUnits;
  }

  public static convertMinorUnitToDisplayFormat(amount: number, currency: CurrencyModel | undefined): string {
    if (!currency) {
      return "";
    }

    if(!amount) {
      return `${currency.symbol}0.00`;
    }

    const isNegative: boolean = amount < 0;
    const calculatedAmount: number = Math.abs(amount) / currency.minorUnits;
    const formattedAmount: string = CurrencyUtilities.formatNumberWithCommasAndDecimals(calculatedAmount);

    return `${isNegative ? '-' : ''}${currency.symbol}${formattedAmount}`;
  }

  public static formatNumberWithCommasAndDecimals(number: number) {  
    let fixedNumber = number.toFixed(2);
    return parseFloat(fixedNumber).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  
}
